import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import apiService from "../APIService";
import BackupIcon from "@mui/icons-material/Backup";
import CloseIcon from "@mui/icons-material/Close";

const UploadFile = forwardRef((props, ref) => {
  const { isAttachementDisable, setAttachementImg ,setEnableAttachment ,} = props
  const [selected, setSelected] = useState("Choose File");
  const [sizeError, setSizeError] = useState("");
  const [fileName, setFileName] = useState("");
  const [apiError, setApiError] = useState("");
  const [path, setPath] = useState("");
  const [preview, setPreview] = useState("");
  const [size, setSize] = useState("");
  const [upload, setUpload] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [onClick, setOnClick] = useState(false);

  const data = props.item?.data ? JSON.parse(props.item.data) : {};
  const type = data.extensions;
  const maxSize = (data.max_size || 512) * 1024;

  const handleChange = (e) => {
    const file = e?.target?.files && e?.target?.files[0];
    if (!file) return;

    const name = file.name;
    setFileName(name);

    // Check file format
    const fileExtension = name.split(".").pop().toLowerCase();
    if (!type?.some((el) => el.includes(fileExtension))) {
      setApiError("*File extension should be jpeg, jpg, png");
      setPreview(URL.createObjectURL(file));
      return;
    }

    // Check file size
    if (file.size > maxSize) {
      setPreview(URL.createObjectURL(file));
      props?.setShowErrorPopUp(true);
      return;
    }

    // setApiError("");
    // setUpload(true);
    // setPath(file);
    // setSize(file.size);
    // setPreview(URL.createObjectURL(file));
    // setSelected(name);
    setOnClick(true);
    apiService.uploadMedia(file).then((response) => {
      if (response?.data?.code === 200) {
        props.handleClick(props.item.code, { key1: response.data.key1 });
        props.setTextOnClick(URL.createObjectURL(file));
        setApiError("");
        props.setAttachementImg(isAttachementDisable)
      } else {
        setApiError("Error uploading media");
      }
    }).finally(() => {
      setIsUploading(false);
    });
  };

  const handleUpload = () => {
    if (isUploading) return;
    setIsUploading(true);

    apiService.uploadMedia(path).then((response) => {
      if (response?.data?.code === 200) {
        props.handleClick(props.item.code, { key1: response.data.key1 });
        props.setTextOnClick(preview);
        setApiError("");
        setEnableAttachment(false)
   
        
      } else {
        setApiError("Error uploading media");
      }
    }).finally(() => {
      setIsUploading(false);
    });
  };

  const handleClose = () => {
    setFileName("");
    setApiError("");
    setSizeError("");
    setSize("");
    setUpload(false);
    setPath("");
    setPreview("");
  };

  // Expose methods to parent via ref
  useImperativeHandle(ref, () => ({
    triggerFileInput: () => document.getElementById("footerFileInput").click(),
    handleUpload
  }));
  

  return (
    <div className="chat-text">
      {/* Hidden file input */}
      <input
        type="file"
        id="footerFileInput"
        accept=".jpeg, .jpg, .png"
        style={{ display: "none" }}
        onChange={handleChange}
      />

      <div style={{ cursor: "pointer", margin : '0px'}}   onClick={() => document.getElementById("footerFileInput").click()} className={!onClick ? "chat-label action-tab action-button" : "chat-label-select action-tab action-button"} >
        {/* "Add Photos" button that triggers file input */}
        {props.item?.text ? props.item?.text : 'Add photos'}
      

        {/* {fileName && (
          <div className="filename-wrap">
            <img src={preview} alt="preview" style={{ width: 40 }} />
            <p style={{ color: "#1890ff", fontSize: 12, paddingLeft: 13 }}>{selected}</p>
            <CloseIcon style={{ cursor: "pointer", fontSize: 13 }} onClick={handleClose} />
          </div>
        )} */}

        {/* {upload && (
          <button className="upload-btn" onClick={handleUpload} disabled={isUploading}>
            {isUploading ? "Uploading..." : "Upload"}
          </button>
        )} */}
      </div>

      {apiError && <p style={{ color: "red" }}>{apiError}</p>}
    </div>
  );
});

export default UploadFile;
